export const hiringManagerLinkedInQueryKeys = {
  all: ['hiring-manager', 'linkedin-account'] as const,
  account: (tenantId: string | undefined) =>
    [...hiringManagerLinkedInQueryKeys.all, tenantId] as const,
};
